export default function Header(props) {

	return (
		<>
			<div className="navigation-bar"></div>
            <div className="main-nav desktop">
				<div className="wrapper-980">
					<div className="display-table" role="navigation" id="mainMenu" aria-label="Main">
						<div className="display-row">
							<div className="display-cell logo-box">
								<a href="https://www.blackrock.com/us/financial-professionals" target="_blank"> 
                            		<div className="logo"><img src="https://charts.blackrock.com/images/blackrock-advisor-center-logo-nav.svg" alt="BlackRock for Advisors homepage"/></div>
                            	</a>
                            </div>
                		</div>   
               		</div>
				</div>
			</div>
		</>
	)
}